module.exports = function(vars) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<i class="fa fa-close close-button broadcast-overlay-close"></i>\n<div class="player-segment broadcast-overlay-segment">\n	';
 if ( vars.noTitle ){ ;
__p += '\n		<h1 class="h1 broadcast-tile">' +
__e( vars.startTime ) +
'</h1>\n	';
 } else { ;
__p += '\n		<h1 class="h1 broadcast-title">' +
__e( vars.title ) +
'</h1>\n		<p class="broadcast-meta">' +
__e( vars.startTime ) +
'</p>\n	';
 } ;
__p += '\n	<a class="btn btn-default broadcast-button btn-lg" target="_blank" href="' +
__e( vars.googleCalenderLink ) +
'"><i class="fa fa-calendar"></i> Add a Reminder to Google Calendar</a>\n</div>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/broadcast-overlay.ejs